"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const errorMessage_style_1 = __importDefault(require("./errorMessage.style"));
const ErrorMessage = ({ classes, text, dataCy }) => (jsx_runtime_1.jsx("div", Object.assign({ className: classes.content, "data-cy": dataCy || 'atomic-error-message' }, { children: text }), void 0));
exports.ErrorMessage = ErrorMessage;
exports.ErrorMessage.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    text: prop_types_1.default.string.isRequired,
    dataCy: prop_types_1.default.string
};
exports.ErrorMessage.defaultProps = {
    dataCy: ''
};
exports.default = react_jss_1.default(errorMessage_style_1.default)(exports.ErrorMessage);
//# sourceMappingURL=errorMessage.js.map